export let primaryColor = '#8c7aa2';
export let darkPrimaryColor = "#8c7aa2b3";
export let secondaryColor = '#dddbdb';
export let footerColor1 = "#8c7aa2";

export let iconsColor = "#8C7AA2";

export let haderColor = "#ffffff";
export let navLinksColor = "#414040";
export let navLinksHoverColor = "#868585";
export let highlightColor = "#8c7aa2";
export let highlightBgColor = "#dddbdb";
export let PageBackgroundColor = '#fff';
export let TextColor = '#222';
export let ButtonsColor = '#8c7aa266';
export let fontFamilyall ='Nunito Sans';
export let buttonHoverColor = "#8c7aa266";
export let buttonColor = "#B6A9C7";


///////category card colors

 export const colors = [
    "linear-gradient(to right, #ff9a9e, #fad0c4)",
    "linear-gradient(to right, #a1c4fd, #c2e9fb)",
    "linear-gradient(to right, #d4fc79, #96e6a1)",
    "linear-gradient(to right, #fbc2eb, #a6c1ee)",
    "linear-gradient(to right, #fdfbfb, #ebedee)",
  ];
////
export const COLORSCHAT={
  primaryColor:"#B2AFAF",
  overlayColor:"lightgrey",
  secondaryColor:"#1F4A45",
  whiteColor:"#fff",
  blackColor:"#000"
  
}